<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header-w-icon">
        <img src="assets\svg\dialog\Danger-w.svg" alt="Alert" class="flx-modal__icon">
        <h2>Missing Configuration</h2>
    </div>
    <div class="flx-modal__subheader">
        <h3>One more setting is needed before this template can be used</h3>
    </div>
    <div class="flx-modal__body"> 
        <p class="text-12 font-medium">The template {{data?.tmplName}} won't appear in the list because the job order type required to display isn't configured. Would you like to add it now?</p>
    </div>
     <div class="flx-modal__footer">
            <button class="custella-btn-white" (click)="cancelAddType()">Not Now</button>
            <p-button label="Add Type and Continue" styleClass="h-32" type="button" icon="fa-regular fa-plus" (onClick)="onAddType()"></p-button>
        </div>
</div>